import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { SurveyService } from "src/app/core/services/survey.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Check } from "src/app/shared/models/check";
import { SurveyResponse } from "src/app/shared/models/survey.model";

@Component({
	selector: "app-customer-survey-result",
	templateUrl: "./customer-survey-result.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSurveyResultComponent implements OnInit {
	surveyKey: string;
	responseKey: string;

	surveyResponse: SurveyResponse;
	surveyCheck: Check;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		public venueService: OOVenueService,
		public surveyService: SurveyService,
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {}

	ngOnInit(): void {
		this.surveyKey = this.activatedRoute.snapshot.paramMap.get("surveyKey");
		this.responseKey = this.activatedRoute.snapshot.paramMap.get("responseKey");
		this.surveyResponse = this.surveyService.surveyResponseList.value.find((i) => i.sk === this.responseKey);
	}

	back() {
		this.router.navigate([`cc/customers/survey`], {
			queryParams: { source: this.responseKey },
		});
	}
}
